module.exports = __webpack_public_path__ + "img/NERO.eb5f1101.svg";